import { transition } from '@angular/animations';
import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/api';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { GroupPalletStock, PalletStock, PalletStockFilter, PalletStockListFilter } from 'src/app/domain/models/PalletStock';



@Component({
  selector: 'app-filter-pallet-stock',
  templateUrl: './filter-pallet-stock.component.html',
  styleUrls: ['./filter-pallet-stock.component.css'],

})
export class FilterPalletStockComponent implements OnInit, OnChanges, AfterViewInit {


  constructor(
    public translate: TranslateService,
    public _palletStockService: PalletStockGateway,
    public _messageService: MessageService
  )
  {
  }

  @Input()
  palletStock: PalletStock[] = []

  @Input()
  loading: boolean = false;

  @Input()
  stockId: number | undefined;

  palletStockFilter: PalletStockListFilter = {
    containerList: [],
    growerList: [],
    speciesList: [],
    speciesSizeList: [],
    varietyList: [],
    programNameList: []
  }

  @Input()
  groupPalletStock: GroupPalletStock[] = []

  specieFilter: SelectItem[] = []
  varietyFilter: SelectItem[] = []
  containerFilter: SelectItem[] = []
  statusFilter: SelectItem[] = []
  producerFilter: SelectItem[] = []
  speciesSizeFilter: SelectItem[] = []
  programNameFilter: SelectItem[] = []

  specieValue: string[] = []
  varietyValue: string[] = []
  containerValue: string[] = []
  statusValue: number[] = []
  producerValue: string[] = []
  speciesSizeValue: string[] = []
  programNameValue: string[] = []

  @Output()
  applyFilterEvent: EventEmitter<PalletStockFilter> = new EventEmitter<PalletStockFilter>()

  ngOnInit(): void
  {
    this.getPalletStockFilter();
  }

  getPalletStockFilter()
  {
    if(this.stockId)
    {
      this.loading = true;
      this._palletStockService.getPalletStockFilter(this.stockId).subscribe({
        next: (v) => {
            this.palletStockFilter = v
            this.configFilter()
            this.loading = false;
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetPalletStockFilters') })
        }
      })
    }
  }

  ngAfterViewInit(): void {
     this.translate.get([
      'UserPalletStock.NotUsedStatus',
      'UserPalletStock.UsedStatus',
      'UserPalletStock.DispatchStatus'
     ]).subscribe({
      next: (translations) => {
          let status = [
          {
            label: translations['UserPalletStock.NotUsedStatus'],
            value: 0
          },
          {
            label:translations['UserPalletStock.UsedStatus'],
            value: 1
          },
          {
            label: translations['UserPalletStock.DispatchStatus'],
            value: 2
          },
          ]

          status.forEach(x => {
            this.statusFilter.push(x)
          })
      }
     })

  }

  configFilter()
  {
    this.specieFilter = []
    this.containerFilter = []
    this.varietyFilter = []
    this.speciesSizeFilter = []
    this.producerFilter = []
    this.programNameFilter = []

    this.specieValue = []
    this.varietyValue = []
    this.containerValue = []
    this.statusValue = []
    this.programNameValue = []

    if(this.palletStockFilter)
    {
      this.palletStockFilter.containerList.map(x => this.containerFilter.push({label: x, value: x}));
      this.palletStockFilter.speciesList.map(x => this.specieFilter.push({label: x, value: x}));
      this.palletStockFilter.varietyList.map(x => this.varietyFilter.push({label: x, value: x}));
      this.palletStockFilter.speciesSizeList.map(x => this.speciesSizeFilter.push({label: x, value: x}));
      this.palletStockFilter.growerList.map(x => this.producerFilter.push({label: x, value: x}));
      this.palletStockFilter.programNameList.map(x => this.programNameFilter.push({label: x, value: x}));
    }

      this.applyFiler()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['stockId'])
    {
      this.getPalletStockFilter();
    }
  }

  applyFiler()
  {

    let filter: PalletStockFilter = {
      speciesFilter: this.specieValue,
      varietyFilter: this.varietyValue,
      containerFilter: this.containerValue,
      statusFilter: this.statusValue,
      speciesSizeFilter: this.speciesSizeValue,
      growerFilter: this.producerValue,
      programNameFilter: this.programNameValue
    }
    this.applyFilterEvent.emit(filter);
  }

}
